var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66659 2.66634C4.45745 2.66634 2.66659 4.4572 2.66659 6.66634C2.66659 8.87548 4.45745 10.6663 6.66659 10.6663C8.87572 10.6663 10.6666 8.87548 10.6666 6.66634C10.6666 4.4572 8.87572 2.66634 6.66659 2.66634ZM1.33325 6.66634C1.33325 3.72082 3.72107 1.33301 6.66659 1.33301C9.6121 1.33301 11.9999 3.72082 11.9999 6.66634C11.9999 9.61186 9.6121 11.9997 6.66659 11.9997C3.72107 11.9997 1.33325 9.61186 1.33325 6.66634ZM11.1952 11.1949C11.4555 10.9346 11.8776 10.9346 12.138 11.1949L14.4713 13.5283C14.7317 13.7886 14.7317 14.2107 14.4713 14.4711C14.211 14.7314 13.7889 14.7314 13.5285 14.4711L11.1952 12.1377C10.9348 11.8774 10.9348 11.4553 11.1952 11.1949Z",
    fill: "#6A7282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.90713f8dd0cf4b17013319f5618d127f.svg";
export { ForwardRef as ReactComponent };